import { IData } from '../interface';

interface IPROD_SYSTEM_SCRIPT_MAP {
    [key: string]: string;
}

const render = (data: IData) => {
    if (data.IS_PRODUCTION) {
        const PROD_SYSTEM_SCRIPT_MAP: IPROD_SYSTEM_SCRIPT_MAP = {
            '"CN"': '<script src="https://statics-cdn-cn.umucdn.cn/statics/js/boot.min.js?v=1.2_{{pageData.version | default(0)}}" type="text/javascript"></script>',
            'CN': '<script src="https://statics-cdn-cn.umucdn.cn/statics/js/boot.min.js?v=1.2_{{pageData.version | default(0)}}" type="text/javascript"></script>',
            '"EM"': '<script src="https://cdn.umu.io/statics/js/boot.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
            'EM': '<script src="https://cdn.umu.io/statics/js/boot.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
            '"JP"': '<script src="https://dpfrzbu0cqnmm.cloudfront.net/statics/js/boot.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
            'JP': '<script src="https://dpfrzbu0cqnmm.cloudfront.net/statics/js/boot.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
            '"TW"': '<script src="https://d1yemi1ss2f2oh.cloudfront.net/statics/js/boot.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
            'TW': '<script src="https://d1yemi1ss2f2oh.cloudfront.net/statics/js/boot.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        };
        return PROD_SYSTEM_SCRIPT_MAP[data.SYSTEM] || '';
    }

    const DEV_SYSTEM_SCRIPT_MAP: IPROD_SYSTEM_SCRIPT_MAP = {
        '"CN"': '<script src="https://statics-cdn-cn.umucdn.cn/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        'CN': '<script src="https://statics-cdn-cn.umucdn.cn/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        '"EM"': '<script src="https://cdn.umu.io/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        'EM': '<script src="https://cdn.umu.io/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        '"JP"': '<script src="https://dpfrzbu0cqnmm.cloudfront.net/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        'JP': '<script src="https://dpfrzbu0cqnmm.cloudfront.net/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        '"TW"': '<script src="https://d1yemi1ss2f2oh.cloudfront.net/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        'TW': '<script src="https://d1yemi1ss2f2oh.cloudfront.net/statics/js/boot.test.min.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
    };
    return DEV_SYSTEM_SCRIPT_MAP[data.SYSTEM] || '';
};

export const getGdprBootJsUrl = (IS_PRODUCTION: boolean, SYSTEM: string) => {
    if (IS_PRODUCTION) {
        const PROD_SYSTEM_SCRIPT_MAP: IPROD_SYSTEM_SCRIPT_MAP = {
            '"EN"': 'https://d1bvk99i2a79wx.cloudfront.net/statics/js/boot.min.js',
            'EN': 'https://d1bvk99i2a79wx.cloudfront.net/statics/js/boot.min.js',
        };
        return PROD_SYSTEM_SCRIPT_MAP[SYSTEM] || '';
    }

    const DEV_SYSTEM_SCRIPT_MAP: IPROD_SYSTEM_SCRIPT_MAP = {
        '"EN"': 'https://d1bvk99i2a79wx.cloudfront.net/statics/js/boot.test.min.js',
        'EN': 'https://d1bvk99i2a79wx.cloudfront.net/statics/js/boot.test.min.js',
    };
    return DEV_SYSTEM_SCRIPT_MAP[SYSTEM] || '';
};

export default render;
